'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RemoveButton = require('./components/RemoveButton.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RemoveButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-buttons/lib/components/remove/index.js
// module id = 1048
// module chunks = 1